import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { sessionStore } from '@/shared/auth/session-store';
import { useSession } from '@/shared/auth/use-session';

/**
 * 로그인이 필요한 화면(결제·결제 결과·충전 내역) — 세션이 없으면 로그인으로 보내고 돌아올 경로를 기억한다.
 * 토스 결제창에서 돌아온 successUrl·failUrl 도 여기 있다 (세션은 localStorage 에 남아 있다).
 * 화면을 보는 중에 세션이 끝나는 경우는 루트의 SessionWatcher 가 옮긴다.
 */
export const Route = createFileRoute('/_app/_auth')({
  beforeLoad: ({ location }) => {
    if (!sessionStore.get()) {
      throw redirect({ to: '/login', search: { redirect: location.href } });
    }
  },
  component: AuthLayout,
});

function AuthLayout() {
  const session = useSession();
  if (!session) return null;
  return <Outlet />;
}
